<template>
  <DragPanel
    title="目录树"
    :closePanel="closePanel"
    :limitDragArea="limitDragArea"
    class="common-drag-panel currentDrag">
    <div class="catalog-tree-box">
      <div
        class="common-card-tabs-box"
        v-if="roomExist || cadMapExist">
        <el-tabs
          class="tab-primary"
          v-model="activeTab"
          type="card"
          @tab-click="onTabClick">
          <el-tab-pane
            label="构件"
            name="element">
            <BimElemTree
              ref="bimElemTree"
              :isShareDataSet="true"
              :dataSetId="dataSetId"
              :isShowRvtGroup="isShowRvtGroup"
              :bimElemTreeRootData="dataSetTreeData" />
          </el-tab-pane>
          <el-tab-pane
            label="房间和面积"
            name="room"
            v-if="roomExist">
            <div class="common-tree-box">
              <el-tree
                class="dialog-tree-small-primary"
                ref="roomTree"
                :data="roomTreeData"
                :props="defaultRoomProps"
                :default-expanded-keys="['1']"
                node-key="nodeId"
                highlight-current
                :expand-on-click-node="false"
                @node-click="handleRoomNodeClick">
                <div
                  slot-scope="{ data }"
                  class="node-label text-overflow"
                  :title="data.nodeName">
                  {{ data.nodeName }}
                </div>
              </el-tree>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="图纸"
            name="cad"
            v-if="cadMapExist">
            <div class="common-tree-box">
              <el-tree
                class="dialog-tree-small-primary"
                ref="cadMapTree"
                :data="cadMapTreeData"
                :props="defaultProps"
                :default-expanded-keys="cadMapTreeExpanded"
                node-key="nodeId"
                highlight-current
                :expand-on-click-node="false"
                @node-click="handleCadNodeClick">
                <div
                  slot-scope="{ data }"
                  class="node-label text-overflow"
                  :title="data.name">
                  {{ data.name }}
                </div>
              </el-tree>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <BimElemTree
        v-else
        ref="bimElemTree"
        :isShareDataSet="true"
        :dataSetId="dataSetId"
        :isShowRvtGroup="isShowRvtGroup"
        :bimElemTreeRootData="dataSetTreeData" />
    </div>
    <div
      class="bottom-option-box"
      v-if="isOptionVisible">
      <el-checkbox
        class="checkbox-primary"
        v-model="isShowRvtGroup">
        Group目录树
      </el-checkbox>
    </div>
  </DragPanel>
</template>

<script>
import DragPanel from '@/components/CustomDragPanel.vue'
import BimElemTree from '../../singleProject/dataManage/components/BimElemTree'

import {
  getSharedProjectTree,
  isSharedRoomExistService,
  getSharedRoomList,
  getSharedRoomInfo,
  getSharedRoomElement,
  isSharedCadMapExistService,
  getSharedCadMapList
} from '@/service/interface'

export default {
  data() {
    return {
      roomExist: false,
      cadMapExist: false,
      activeTab: 'element',

      dataSetId: '',
      formatType: 1,
      dataSetTreeData: [],
      defaultProps: {
        children: 'nodes',
        label: 'name'
      },
      isShowRvtGroup: false,

      roomTreeData: [],
      defaultRoomProps: {
        children: 'nodes',
        label: 'nodeName'
      },

      cadMapTreeData: [],
      cadMapTreeExpanded: []
    }
  },
  props: {
    limitDragArea: String,
    closePanel: Function,
    updateAttributeType: Function,
    updateAttributeData: Function,
    loadBIMCAD: Function,
    resetElemAttr: Function,
    showRoom: Function,
    highLightElement: Function,
    hiddenDataset: Function,
    showDataset: Function,
    hiddenElement: Function,
    showElement: Function,
    setCanvasViewMode: Function,
    closeCadLayerPanel: Function,
    closeCadLayoutPanel: Function
  },
  components: {
    DragPanel,
    BimElemTree
  },
  computed: {
    isOptionVisible: function () {
      const rootNode = this.dataSetTreeData[0]
      let visible = false
      if (this.formatType === 1) {
        visible = rootNode?.hasRvtGroup
      } else {
        const files = rootNode ? rootNode.files : []
        visible = files.some(el => el.hasRvtGroup)
      }

      return visible
    }
  },
  created() {
    let dataType = this.$route.query.dataType
    if (dataType === 'Bim') {
      this.initCatalogTree().then(() => {
        this.initRoomTree().then(() => {
          this.initCadMapTree().then(() => {
            this.$refs.bimElemTree?.initBimElemTreeData()
          })
        })
      })
    }
  },
  methods: {
    initCatalogTree() {
      return new Promise(resolve => {
        let resourceId = this.$route.params.resourceId
        let params = { dataSetId: resourceId }
        this.dataSetId = resourceId
        let headers = this.getHeaders()
        getSharedProjectTree(params, { headers }).then(response => {
          if (response.isSuccess) {
            let dataSets = response.data

            let formatType = dataSets[0].formatType
            this.formatType = formatType

            let treeData = this.formatDataSetData(dataSets)
            this.dataSetTreeData = treeData
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    initRoomTree() {
      return new Promise(resolve => {
        this.isRoomExist().then(roomExist => {
          if (!roomExist) {
            this.roomExist = false
            this.roomTreeData = []
            resolve()
            return
          }

          let resourceId = this.$route.params.resourceId
          let fileNames = this.getRoomFilesName()
          let params = {
            dataSetId: resourceId,
            fileNames
          }
          let headers = this.getHeaders()
          getSharedRoomList(params, { headers }).then(response => {
            if (response.isSuccess) {
              let data = response.data
              data = data.filter(item => {
                let rooms = item.rooms
                if (rooms[0] && item.elementIntIds) {
                  return true
                } else {
                  return false
                }
              })

              let roomTreeData = data.map(item => {
                item['nodeName'] = item.hostFileName
                item['nodeId'] = item.hostFileId
                item['nodes'] = item.rooms
                return item
              })
              if (roomTreeData.length) {
                this.roomExist = true
                this.roomTreeData = roomTreeData
              } else {
                this.roomExist = false
              }
              resolve()
            }
          })
        })
      })
    },
    initCadMapTree() {
      return new Promise(resolve => {
        this.isCadMapExist().then(cadMapExist => {
          if (!cadMapExist) {
            this.cadMapExist = false
            this.cadMapTreeData = []
            resolve()
            return
          }
        })

        let dataSetId = this.$route.params.resourceId
        let fileNames = this.getRoomFilesName()
        let params = {
          dataSetId,
          fileNames,
          showMaps: false
        }
        let headers = this.getHeaders()
        getSharedCadMapList(params, { headers }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            if (data.length) {
              this.cadMapExist = true

              let cadMapTreeData = this.formatCadMapData(data)
              this.cadMapTreeData = cadMapTreeData
              let defaultData = cadMapTreeData[0]
              this.cadMapTreeExpanded.push(defaultData.nodeId)
              this.$nextTick(() => {
                if (defaultData.nodes && defaultData.nodes.length) {
                  let currKey = defaultData.nodes[0].nodeId
                  this.$refs.cadMapTree.setCurrentKey(currKey)
                }
              })
            } else {
              this.cadMapExist = false
            }
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    onTabClick(tab) {
      if (tab.name === 'element') {
        this.setCanvasViewMode('model')
        this.closeCadLayerPanel()
        this.closeCadLayoutPanel()
        window.BlackHole3D.Clip.endClip()
        this.updateAttributeType('element')
        window.BlackHole3D.Graphics.setSysUIPanelVisible(true)
        window.BlackHole3D.Graphics.setGeoCoordVisible(true)
        window.BlackHole3D.Graphics.setViewCubeVisible(true)

        window.BlackHole3D.setViewMode(
          window.BlackHole3D.REVpTypeEm.BIM,
          window.BlackHole3D.REVpTypeEm.None,
          window.BlackHole3D.REVpRankEm.Single
        )

        this.resetElemAttr()

        this.$refs.dataSetTree.setCheckedKeys([
          this.dataSetTreeData[0].uniqueId
        ])
      }
      if (tab.name === 'room') {
        this.setCanvasViewMode('model')
        this.closeCadLayerPanel()
        this.closeCadLayoutPanel()
        this.updateAttributeType('room')
        window.BlackHole3D.Graphics.setSysUIPanelVisible(true)
        window.BlackHole3D.Graphics.setGeoCoordVisible(true)
        window.BlackHole3D.Graphics.setViewCubeVisible(true)

        window.BlackHole3D.setViewMode(
          window.BlackHole3D.REVpTypeEm.BIM,
          window.BlackHole3D.REVpTypeEm.None,
          window.BlackHole3D.REVpRankEm.Single
        )
      }
      if (tab.name === 'cad') {
        this.setCanvasViewMode('bimCad')
        if (!this.cadMapTreeData.length) {
          this.initCadMapTree().then(() => {
            if (this.cadMapTreeData.length) {
              let cadInfo = this.cadMapTreeData[0].nodes[0]
              // 加载二维图纸
              this.loadBIMCAD(cadInfo)
            }
          })
        } else {
          let cadInfo = this.cadMapTreeData[0].nodes[0]
          // 加载二维图纸
          this.loadBIMCAD(cadInfo)
          this.$refs.cadMapTree.setCurrentKey(cadInfo.nodeId)
        }
      }
    },
    handleRoomNodeClick(nodeData, node) {
      if (!node.isLeaf) return

      let resourceId = this.$route.params.resourceId
      let params = {
        dataSetId: resourceId,
        childNodeId: nodeData.nodeId
      }
      let headers = this.getHeaders()
      getSharedRoomElement(params, { headers })
        .then(response => {
          if (response.isSuccess) {
            let data = response.data
            let childNodeIds = data.elemIntIds
            if (childNodeIds.length) {
              return Promise.resolve(childNodeIds)
            } else {
              return Promise.resolve([])
            }
          }
        })
        .then(childNodeIds => {
          let params2 = {
            dataSetId: resourceId,
            elementIntId: ''
          }
          if (childNodeIds.length) {
            params2['elementIntId'] = childNodeIds[0] + ''
          }
          getSharedRoomInfo(params2, { headers }).then(res => {
            if (res.isSuccess) {
              let attributeData = res.data
              let roomInfo = {}
              attributeData.forEach(item => {
                item['paramGroup'] = item.roomParamGroup
                item.roomParams.forEach(obj => {
                  if (obj.roomParamName === 'LevelBottom') {
                    roomInfo['levelHeightBottom'] = obj.roomParamValue
                  }
                  if (obj.roomParamName === 'LevelTop') {
                    roomInfo['levelHeightTop'] = obj.roomParamValue
                  }

                  obj['paramName'] = obj.roomParamName
                  obj['paramValue'] = obj.roomParamValue
                  obj['paramType'] = obj.roomParamType
                })

                item['paramDatas'] = item.roomParams
              })

              roomInfo['elemIntIds'] = childNodeIds
              this.showRoom(roomInfo)
              this.updateAttributeData(attributeData)
            }
          })
        })
    },
    handleCadNodeClick(nodeData) {
      if (nodeData.customType && nodeData.customType === 'cadParent') return
      this.loadBIMCAD(nodeData)
    },
    /**
     * 获取带有房间信息的文件名
     */
    getRoomFilesName() {
      // 带有房间和图纸信息的模型来源(根据srcCatalog字段判断来源)
      const FileSrcWithRoomInfo = [0, 1, 4]

      let pakNodeDatas = []
      if (this.formatType === 1) {
        pakNodeDatas = this.dataSetTreeData
      } else {
        pakNodeDatas = this.dataSetTreeData[0].nodes
      }
      let roomFiles = pakNodeDatas.filter(el =>
        FileSrcWithRoomInfo.includes(el.srcCatalog)
      )
      let roomFilesName = roomFiles.map(item => {
        return item.name
      })
      return roomFilesName
    },
    /**
     * 获取某一节点下所有子节点
     */
    getDataSets(nodeData) {
      let dataSetId = this.$route.params.resourceId
      let dataSets = []
      ;[nodeData].forEach(item => {
        if (item.fileIntId) {
          dataSets.push({
            dataSetId,
            hostFileId: item.fileIntId
          })
        }
        if (item.nodeId) {
          let tempArray = []
          if (item.nodes.length) {
            this.findAllKeys(item.nodes, tempArray)
          } else {
            this.findAllKeys([item], tempArray)
          }
          tempArray = tempArray.map(el => {
            let obj = {
              dataSetId,
              childNodeId: el
            }
            return obj
          })
          dataSets = [...dataSets, ...tempArray]
        }
      })
      return dataSets
    },
    /**
     * 根据构件节点获取该节点下的所有子节点
     */
    getDataSetsByNodeData(nodeData) {
      let dataSetId = this.$route.query.datasetId
      let dataSets = []
      dataSets.push({
        dataSetId,
        childNodeId: nodeData.nodeId
      })
      let tempArray = []
      if (nodeData.nodes.length) {
        this.findAllKeys(nodeData.nodes, tempArray)
      }
      tempArray = tempArray.map(el => {
        let obj = {
          dataSetId,
          childNodeId: el
        }
        return obj
      })
      dataSets = [...dataSets, ...tempArray]
      return dataSets
    },
    formatDataSetData(dataSets) {
      const formatType = dataSets[0]?.formatType
      let treeData = []
      if (formatType === 1) {
        treeData = dataSets[0].files
        treeData.forEach(item => {
          item['customNodeType'] = 'dataSet'
          item['formatType'] = formatType
          item['name'] = item.fileName
          item['dataSetId'] = dataSets[0].dataSetId
          item['dataSetType'] = dataSets[0].dataSetType
          item.nodes = [{ name: '' }]
        })
      }
      if (formatType === 2) {
        dataSets.forEach(item => {
          item['customNodeType'] = 'dataSet'
          item['name'] = item.dataSetName
          item.nodes = item.files
          item.nodes.forEach(node => {
            node['customNodeType'] = 'file'
            node['name'] = node.fileName
            node.nodes = [{ name: '' }]
          })
        })
        treeData = dataSets
      }
      return treeData
    },
    formatCadMapData(data) {
      data.forEach(item => {
        item['customType'] = 'cadParent'
        item.nodes = item.sheets
        item.name = item.hostFileName
        item.nodeId = item.hostFileId

        let nodes = item.nodes
        if (nodes.length) {
          nodes.forEach(sheet => {
            sheet['nodeId'] = sheet.cadSheetId
            sheet['name'] = sheet.cadSheetName
            sheet['nodes'] = []
          })
        }
      })
      return data
    },
    isRoomExist() {
      return new Promise(resolve => {
        let resourceId = this.$route.params.resourceId
        let params = { dataSetId: resourceId }
        let headers = this.getHeaders()
        isSharedRoomExistService(params, { headers }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data.exist)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    isCadMapExist() {
      return new Promise(resolve => {
        let resourceId = this.$route.params.resourceId
        let params = { dataSetId: resourceId }
        let headers = this.getHeaders()
        isSharedCadMapExistService(params, { headers }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            resolve(data.exist)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    findAllKeys(treeData, array) {
      for (let item of treeData) {
        if (item.nodeId) {
          array.push(item.nodeId)
        }
        if (item.nodes && item.nodes.length) {
          this.findAllKeys(item.nodes, array)
        }
      }
      return array
    },
    getHeaders() {
      let token = this.$route.query.token
      let headers = {
        Authorization: token
      }
      return headers
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/assets/css/publishSearch.less';
.currentDrag {
  width: 290px;
  min-width: 290px;
}
.common-drag-panel {
  top: 60px;
  left: 10px;
  height: calc(100% - 125px);

  :deep(.content) {
    display: flex;
    flex-direction: column;
    height: calc(100% - 40px);

    .catalog-tree-box {
      padding-top: 10px;
      flex-grow: 1;
      min-height: 0;
      text-align: left;

      .common-tree-box {
        height: 100%;
        padding: 5px 10px;
        .node-label {
          font-size: 14px;
          padding-left: 4px;
        }
      }
      .common-card-tabs-box {
        height: calc(100% - 5px);
        margin-top: 5px;
        .el-tabs {
          height: 100%;

          .el-tabs__nav {
            margin-left: 15px;
          }

          .el-tabs__content {
            margin-top: 0px;

            .el-tab-pane {
              height: 100%;
            }
          }
        }

        .el-tabs__header {
          .el-tabs__item {
            color: var(--eng-tab-text-color);
            border: 1px solid var(--eng-tab-border-color) !important;
            background-color: var(--eng-tab-bgColor);

            &:hover {
              background-color: var(--eng-tab-hover-bgColor);
              border: 1px solid transparent !important;
            }

            &.is-active {
              border-color: transparent !important;
            }
          }
        }
      }
    }

    .bottom-option-box {
      padding: 10px;
      text-align: left;
      border-top: 1px solid var(--dialog-split-line-color);

      .checkbox-primary {
        display: flex;
        align-items: center;
      }
    }
  }
}
</style>
